export const carsInfo = [
  {
    typeId: 1,
    typeName: "Otomobil",
    brands: [
      { brandId: 1, brandName: "ALFA ROMEO" },
      { brandId: 2, brandName: "ASTON MARTIN" },
      { brandId: 3, brandName: "AUDI" },
      { brandId: 4, brandName: "SAAB" },
      { brandId: 5, brandName: "SEAT" },
      { brandId: 6, brandName: "BMW" },
      { brandId: 7, brandName: "BUICK" },
      { brandId: 8, brandName: "BMC" },
      { brandId: 9, brandName: "DAEWOO" },
      { brandId: 10, brandName: "CADILLAC" },
      { brandId: 11, brandName: "CHEVROLET" },
      { brandId: 12, brandName: "CHRYSLER" },
      { brandId: 13, brandName: "CITROEN" },
      { brandId: 14, brandName: "DAF" },
      { brandId: 15, brandName: "DAIHATSU" },
      { brandId: 16, brandName: "DODGE/USA" },
      { brandId: 17, brandName: "FERRARI" },
      { brandId: 18, brandName: "FIAT" },
      { brandId: 19, brandName: "FORD/OTOSAN" },
      { brandId: 20, brandName: "HONDA" },
      { brandId: 21, brandName: "ISUZU" },
      { brandId: 22, brandName: "LANCIA" },
      { brandId: 23, brandName: "LINCOLN" },
      { brandId: 24, brandName: "LADA" },
      { brandId: 25, brandName: "MASERATI" },
      { brandId: 26, brandName: "MAZDA" },
      { brandId: 27, brandName: "MERCEDES" },
      { brandId: 28, brandName: "MERCURY" },
      { brandId: 29, brandName: "MITSUBISHI" },
      { brandId: 30, brandName: "TOFAS-FIAT" },
      { brandId: 31, brandName: "OTOKAR/MAGIRUS" },
      { brandId: 32, brandName: "NISSAN" },
      { brandId: 33, brandName: "OPEL" },
      { brandId: 34, brandName: "PEUGEOT" },
      { brandId: 35, brandName: "PONTIAC" },
      { brandId: 36, brandName: "PORSCHE" },
      { brandId: 37, brandName: "TATA" },
      { brandId: 38, brandName: "RENAULT (OYAK)" },
      { brandId: 39, brandName: "RENAULT" },
      { brandId: 40, brandName: "RANGE ROVER" },
      { brandId: 41, brandName: "SSANGYONG" },
      { brandId: 42, brandName: "SUZUKI" },
      { brandId: 43, brandName: "SKODA" },
      { brandId: 44, brandName: "SUBARU" },
      { brandId: 45, brandName: "SCANIA" },
      { brandId: 46, brandName: "TOYOTA" },
      { brandId: 47, brandName: "VOLKSWAGEN" },
      { brandId: 48, brandName: "VOLVO" },
      { brandId: 49, brandName: "FORD /USA" },
      { brandId: 50, brandName: "HYUNDAI" },
      { brandId: 51, brandName: "JAGUAR" },
      { brandId: 52, brandName: "JAC" },
      { brandId: 53, brandName: "GULERYUZ" },
      { brandId: 54, brandName: "LAMBORGHINI" },
      { brandId: 55, brandName: "LOTUS" },
      { brandId: 56, brandName: "MORGAN" },
      { brandId: 57, brandName: "PROTON" },
      { brandId: 58, brandName: "MAN" },
      { brandId: 59, brandName: "ZIRAI TRAKTOR" },
      { brandId: 60, brandName: "VOLVO-TR" },
      { brandId: 61, brandName: "LAND ROVER" },
      { brandId: 62, brandName: "MINI" },
      { brandId: 63, brandName: "NEOPLAN" },
      { brandId: 64, brandName: "DACIA" },
      { brandId: 65, brandName: "SETRA" },
      { brandId: 66, brandName: "SMART" },
      { brandId: 67, brandName: "CATERHAM" },
      { brandId: 68, brandName: "INFINITI" },
      { brandId: 69, brandName: "TESLA" },
      { brandId: 70, brandName: "KTM" },
      { brandId: 71, brandName: "CHANGAN" },
      { brandId: 72, brandName: "FISKER" },
      { brandId: 73, brandName: "SHUANGHUAN" },
      { brandId: 74, brandName: "TCV" },
      { brandId: 75, brandName: "OTOYOLIVECOFIAT" },
      { brandId: 76, brandName: "TURKKAR" },
      { brandId: 77, brandName: "TEZELLER" },
      { brandId: 78, brandName: "TEMSA" },
      { brandId: 79, brandName: "ASKAM/FARGO/DESOTO" },
      { brandId: 80, brandName: "HUMMER" },
      { brandId: 81, brandName: "AR-BUS" },
      { brandId: 82, brandName: "IKCO" },
      { brandId: 83, brandName: "BENTLEY" },
      { brandId: 84, brandName: "KARSAN" },
      { brandId: 85, brandName: "PIAGGIO" },
      { brandId: 86, brandName: "HUANGHAI" },
      { brandId: 87, brandName: "VISEON" },
      { brandId: 88, brandName: "KENWORTH" },
      { brandId: 89, brandName: "IRIZAR" },
      { brandId: 90, brandName: "SAIPA" },
      { brandId: 91, brandName: "LEXUS" },
      { brandId: 92, brandName: "SOLARIS" },
      { brandId: 93, brandName: "BOZANKAYA" },
      { brandId: 94, brandName: "MULTICAR" },
      { brandId: 95, brandName: "ADRIA" },
      { brandId: 96, brandName: "HAIMA" },
      { brandId: 97, brandName: "MILLER" },
      { brandId: 98, brandName: "SCHMIDT" },
      { brandId: 99, brandName: "RAVON" },
      { brandId: 100, brandName: "EMT" },
      { brandId: 101, brandName: "ZOTYE" },
      { brandId: 102, brandName: "PILOTCAR" },
      { brandId: 103, brandName: "MCLAREN" },
      { brandId: 104, brandName: "ALPINE" },
      { brandId: 105, brandName: "MG" },
      { brandId: 106, brandName: "XEV" },
      { brandId: 107, brandName: "SERES" },
      { brandId: 108, brandName: "CUPRA" },
      { brandId: 109, brandName: "DONG FENG" },
      { brandId: 110, brandName: "TRUMPCHI/GAC" },
      { brandId: 111, brandName: "ORA" },
      { brandId: 112, brandName: "BRILLIANCE" },
      { brandId: 113, brandName: "MOTORSIKLET" },
      { brandId: 114, brandName: "ALKE" },
      { brandId: 115, brandName: "MEGA" },
      { brandId: 116, brandName: "AIXAM" },
      { brandId: 117, brandName: "FOLKVAN" },
      { brandId: 118, brandName: "PGO" },
      { brandId: 119, brandName: "MJT" },
      { brandId: 120, brandName: "SCAM" },
      { brandId: 121, brandName: "DFM" },
      { brandId: 122, brandName: "HFKANUNI" },
      { brandId: 123, brandName: "MAHINDRA" },
      { brandId: 124, brandName: "CHERY" },
      { brandId: 125, brandName: "TURKAR" },
      { brandId: 126, brandName: "KOENIGSEGG" },
      { brandId: 127, brandName: "GONOW" },
      { brandId: 128, brandName: "ASTRA" },
      { brandId: 129, brandName: "AVIA" },
      { brandId: 130, brandName: "VEICOLI" },
      { brandId: 131, brandName: "SINOTRUK" },
      { brandId: 132, brandName: "BREDAMENARIBUS" },
      { brandId: 133, brandName: "MAYBACH" },
      { brandId: 134, brandName: "PETERBILT" },
      { brandId: 135, brandName: "WIESMANN" },
      { brandId: 136, brandName: "HYMER" },
      { brandId: 137, brandName: "ROLLS-ROYCE" },
      { brandId: 138, brandName: "AKIA" },
      { brandId: 139, brandName: "THE LONDON TAXI" },
      { brandId: 140, brandName: "GREAT WALL" },
      { brandId: 141, brandName: "GROVE" },
      { brandId: 142, brandName: "HISCAR" },
      { brandId: 143, brandName: "BYD" },
      { brandId: 144, brandName: "ZOOMLION" },
      { brandId: 145, brandName: "CODA" },
      { brandId: 146, brandName: "TATRA" },
      { brandId: 147, brandName: "TADANO FAUN" },
      { brandId: 148, brandName: "MENARINIBUS" },
      { brandId: 149, brandName: "PIMAKINA" },
      { brandId: 150, brandName: "DS" },
      { brandId: 151, brandName: "MAZ" },
      { brandId: 152, brandName: "SKYWELL" },
      { brandId: 153, brandName: "KIA" },
      { brandId: 154, brandName: "BUGATTI" },
      { brandId: 155, brandName: "GEELY" },
      { brandId: 156, brandName: "FAW" },
      { brandId: 157, brandName: "ISOBUS" },
      { brandId: 158, brandName: "DFSK" },
      { brandId: 159, brandName: "GMC" },
      { brandId: 160, brandName: "GAZ" },
      { brandId: 161, brandName: "TOG" },
    ],
  },
  {
    typeId: 2,
    typeName: "4 Teker Hafif Ticari",
    brands: [
      { brandId: 1, brandName: "ALFA ROMEO" },
      { brandId: 2, brandName: "ASTON MARTIN" },
      { brandId: 3, brandName: "AUDI" },
      { brandId: 4, brandName: "SAAB" },
      { brandId: 5, brandName: "SEAT" },
      { brandId: 6, brandName: "BMW" },
      { brandId: 7, brandName: "BUICK" },
      { brandId: 8, brandName: "BMC" },
      { brandId: 9, brandName: "DAEWOO" },
      { brandId: 10, brandName: "CADILLAC" },
      { brandId: 11, brandName: "CHEVROLET" },
      { brandId: 12, brandName: "CHRYSLER" },
      { brandId: 13, brandName: "CITROEN" },
      { brandId: 14, brandName: "DAF" },
      { brandId: 15, brandName: "DAIHATSU" },
      { brandId: 16, brandName: "DODGE/USA" },
      { brandId: 17, brandName: "FERRARI" },
      { brandId: 18, brandName: "FIAT" },
      { brandId: 19, brandName: "FORD/OTOSAN" },
      { brandId: 20, brandName: "HONDA" },
      { brandId: 21, brandName: "ISUZU" },
      { brandId: 22, brandName: "LANCIA" },
      { brandId: 23, brandName: "LINCOLN" },
      { brandId: 24, brandName: "LADA" },
      { brandId: 25, brandName: "MASERATI" },
      { brandId: 26, brandName: "MAZDA" },
      { brandId: 27, brandName: "MERCEDES" },
      { brandId: 28, brandName: "MERCURY" },
      { brandId: 29, brandName: "MITSUBISHI" },
      { brandId: 30, brandName: "TOFAS-FIAT" },
      { brandId: 31, brandName: "OTOKAR/MAGIRUS" },
      { brandId: 32, brandName: "NISSAN" },
      { brandId: 33, brandName: "OPEL" },
      { brandId: 34, brandName: "PEUGEOT" },
      { brandId: 35, brandName: "PONTIAC" },
      { brandId: 36, brandName: "PORSCHE" },
      { brandId: 37, brandName: "TATA" },
      { brandId: 38, brandName: "RENAULT (OYAK)" },
      { brandId: 39, brandName: "RENAULT" },
      { brandId: 40, brandName: "RANGE ROVER" },
      { brandId: 41, brandName: "SSANGYONG" },
      { brandId: 42, brandName: "SUZUKI" },
      { brandId: 43, brandName: "SKODA" },
      { brandId: 44, brandName: "SUBARU" },
      { brandId: 45, brandName: "SCANIA" },
      { brandId: 46, brandName: "TOYOTA" },
      { brandId: 47, brandName: "VOLKSWAGEN" },
      { brandId: 48, brandName: "VOLVO" },
      { brandId: 49, brandName: "FORD /USA" },
      { brandId: 50, brandName: "HYUNDAI" },
      { brandId: 51, brandName: "JAGUAR" },
      { brandId: 52, brandName: "JAC" },
      { brandId: 53, brandName: "GULERYUZ" },
      { brandId: 54, brandName: "LAMBORGHINI" },
      { brandId: 55, brandName: "LOTUS" },
      { brandId: 56, brandName: "MORGAN" },
      { brandId: 57, brandName: "PROTON" },
      { brandId: 58, brandName: "MAN" },
      { brandId: 59, brandName: "ZIRAI TRAKTOR" },
      { brandId: 60, brandName: "VOLVO-TR" },
      { brandId: 61, brandName: "LAND ROVER" },
      { brandId: 62, brandName: "MINI" },
      { brandId: 63, brandName: "NEOPLAN" },
      { brandId: 64, brandName: "DACIA" },
      { brandId: 65, brandName: "SETRA" },
      { brandId: 66, brandName: "SMART" },
      { brandId: 67, brandName: "CATERHAM" },
      { brandId: 68, brandName: "INFINITI" },
      { brandId: 69, brandName: "TESLA" },
      { brandId: 70, brandName: "KTM" },
      { brandId: 71, brandName: "CHANGAN" },
      { brandId: 72, brandName: "FISKER" },
      { brandId: 73, brandName: "SHUANGHUAN" },
      { brandId: 74, brandName: "TCV" },
      { brandId: 75, brandName: "OTOYOLIVECOFIAT" },
      { brandId: 76, brandName: "TURKKAR" },
      { brandId: 77, brandName: "TEZELLER" },
      { brandId: 78, brandName: "TEMSA" },
      { brandId: 79, brandName: "ASKAM/FARGO/DESOTO" },
      { brandId: 80, brandName: "HUMMER" },
      { brandId: 81, brandName: "AR-BUS" },
      { brandId: 82, brandName: "IKCO" },
      { brandId: 83, brandName: "BENTLEY" },
      { brandId: 84, brandName: "KARSAN" },
      { brandId: 85, brandName: "PIAGGIO" },
      { brandId: 86, brandName: "HUANGHAI" },
      { brandId: 87, brandName: "VISEON" },
      { brandId: 88, brandName: "KENWORTH" },
      { brandId: 89, brandName: "IRIZAR" },
      { brandId: 90, brandName: "SAIPA" },
      { brandId: 91, brandName: "LEXUS" },
      { brandId: 92, brandName: "SOLARIS" },
      { brandId: 93, brandName: "BOZANKAYA" },
      { brandId: 94, brandName: "MULTICAR" },
      { brandId: 95, brandName: "ADRIA" },
      { brandId: 96, brandName: "HAIMA" },
      { brandId: 97, brandName: "MILLER" },
      { brandId: 98, brandName: "SCHMIDT" },
      { brandId: 99, brandName: "RAVON" },
      { brandId: 100, brandName: "EMT" },
      { brandId: 101, brandName: "ZOTYE" },
      { brandId: 102, brandName: "PILOTCAR" },
      { brandId: 103, brandName: "MCLAREN" },
      { brandId: 104, brandName: "ALPINE" },
      { brandId: 105, brandName: "MG" },
      { brandId: 106, brandName: "XEV" },
      { brandId: 107, brandName: "SERES" },
      { brandId: 108, brandName: "CUPRA" },
      { brandId: 109, brandName: "DONG FENG" },
      { brandId: 110, brandName: "TRUMPCHI/GAC" },
      { brandId: 111, brandName: "ORA" },
      { brandId: 112, brandName: "BRILLIANCE" },
      { brandId: 113, brandName: "MOTORSIKLET" },
      { brandId: 114, brandName: "ALKE" },
      { brandId: 115, brandName: "MEGA" },
      { brandId: 116, brandName: "AIXAM" },
      { brandId: 117, brandName: "FOLKVAN" },
      { brandId: 118, brandName: "PGO" },
      { brandId: 119, brandName: "MJT" },
      { brandId: 120, brandName: "SCAM" },
      { brandId: 121, brandName: "DFM" },
      { brandId: 122, brandName: "HFKANUNI" },
      { brandId: 123, brandName: "MAHINDRA" },
      { brandId: 124, brandName: "CHERY" },
      { brandId: 125, brandName: "TURKAR" },
      { brandId: 126, brandName: "KOENIGSEGG" },
      { brandId: 127, brandName: "GONOW" },
      { brandId: 128, brandName: "ASTRA" },
      { brandId: 129, brandName: "AVIA" },
      { brandId: 130, brandName: "VEICOLI" },
      { brandId: 131, brandName: "SINOTRUK" },
      { brandId: 132, brandName: "BREDAMENARIBUS" },
      { brandId: 133, brandName: "MAYBACH" },
      { brandId: 134, brandName: "PETERBILT" },
      { brandId: 135, brandName: "WIESMANN" },
      { brandId: 136, brandName: "HYMER" },
      { brandId: 137, brandName: "ROLLS-ROYCE" },
      { brandId: 138, brandName: "AKIA" },
      { brandId: 139, brandName: "THE LONDON TAXI" },
      { brandId: 140, brandName: "GREAT WALL" },
      { brandId: 141, brandName: "GROVE" },
      { brandId: 142, brandName: "HISCAR" },
      { brandId: 143, brandName: "BYD" },
      { brandId: 144, brandName: "ZOOMLION" },
      { brandId: 145, brandName: "CODA" },
      { brandId: 146, brandName: "TATRA" },
      { brandId: 147, brandName: "TADANO FAUN" },
      { brandId: 148, brandName: "MENARINIBUS" },
      { brandId: 149, brandName: "PIMAKINA" },
      { brandId: 150, brandName: "DS" },
      { brandId: 151, brandName: "MAZ" },
      { brandId: 152, brandName: "SKYWELL" },
      { brandId: 153, brandName: "KIA" },
      { brandId: 154, brandName: "BUGATTI" },
      { brandId: 155, brandName: "GEELY" },
      { brandId: 156, brandName: "FAW" },
      { brandId: 157, brandName: "ISOBUS" },
      { brandId: 158, brandName: "DFSK" },
      { brandId: 159, brandName: "GMC" },
      { brandId: 160, brandName: "GAZ" },
      { brandId: 161, brandName: "TOG" },
    ],
  },
];
